export const maxItemsSKU = 50
